<script setup>
import { ref, onMounted, watch, onBeforeUnmount, computed } from 'vue';
import DOMPurify from 'dompurify';
import tocbot from 'tocbot';
import TocBot from './TocBot.vue';
import BlogDetailSocialShare from './SocialShare.vue';

// Props
const props = defineProps({
  body: {
    type: String,
    required: true,
  },
  title: String,
  slug: String,
  id: String,
  metaDescription: String,
  tags: Array,
});

// Reactive state
const finalBody = computed(() => props.body);
const finalHtml = ref('');

// Watch and process content when mounted
onMounted(async () => {
  if (!finalBody.value) return;

  const parsedHtml = DOMPurify.sanitize(finalBody.value);
  const parser = new DOMParser();
  const doc = parser.parseFromString(parsedHtml, 'text/html');
  const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');

  headings.forEach((heading) => {
    if (!heading.id && heading.textContent) {
      heading.id = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w]+/g, '-');
    }
  });
  

  finalHtml.value = doc.documentElement.outerHTML;
});

onBeforeUnmount(() => {
  tocbot.destroy();
});
</script>

<template>
  <div v-if="finalHtml" class="banner">
    <div class="pb-16">
      <v-row class="">
        <v-col cols="12" lg="8" class="">
          <div class="js-toc-content prose" v-html="finalHtml" />
        </v-col>
        <v-col cols="12" lg="4">
          <div class="d-none d-lg-block blog-sidebar">
            <div class="blog-toc ">
              <h4 class="text-primary">Table of Contents</h4>
              <div class="js-toc blog-table-of-content">
                <TocBot />
              </div>
            </div>
            <BlogDetailSocialShare
              :tags="tags"
              :title="title"
              :slug="slug"
              :id="id"
              :metaDescription="metaDescription"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style>
.blog-sidebar {
  position: sticky !important;
  top: 120px;
  max-height: max-content;
}
.blog-sidebar .blog-toc {
  text-align: left;
  background-color: white !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

.blog-sidebar .blog-table-of-content {
  /* position: sticky !important;
  top: 55px !important; */
  font-size: 14px;
}

.blog-sidebar .blog-table-of-content .toc-list .toc-list-item {
  padding: 10px !important;
}
.toc-list-item {
  list-style-type: none !important;
}
.toc-link {
  text-decoration: none;
}

.blog-sidebar
  .blog-table-of-content
  .toc-list
  .toc-list-item
  .toc-link::before {
  height: 20px;
  margin-left: 10px;
  width: 3px;
  margin-top: 2px;
}

.js-toc-content ul {
  padding-left: 20px; /* puts bullet inside the text block */
}

.is-active-li .toc-link::before {
  background-color: #00aeff;
}
@media only screen and (max-width: 1280px){
  .banner {
    padding: 0 5rem;
  }
}
@media only screen and (max-width: 1050px){
  .banner {
    padding: 0 4rem;
  }
}
@media only screen and (max-width: 840px){
  .banner {
    padding: 0 3rem;
  }
}
@media only screen and (max-width: 640px){
  .banner {
    padding: 0 2rem;
  }
}
@media only screen and (max-width: 470px){
  .banner {
    padding: 0 1rem;
  }
}
</style>
 